import { useState, useEffect } from 'react';

const useBlogPosts = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('/posts/index.json')
            .then((r) => {
                if (!r.ok) throw new Error('Failed to load posts');
                return r.json();
            })
            .then((data) => {
                setPosts(data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    return { posts, loading, error };
};

export default useBlogPosts;
